import { render, staticRenderFns } from "./IlluConseilPedagogique.vue?vue&type=template&id=7474cf58&"
import script from "./IlluConseilPedagogique.vue?vue&type=script&lang=js&"
export * from "./IlluConseilPedagogique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports